import { ArrowRight, ArrowDown, Check, ShieldOff } from "lucide-react";
import { Reveal } from "./Reveal";
import { FLOW_STEPS, TRACKING_LIST } from "../../data/smartContent";

export const SmartHowItWorks = () => (
  <section id="cum-functioneaza" data-testid="section-cum-functioneaza" className="scroll-mt-20 bg-white py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="max-w-3xl">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-isic">Cum funcționează</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl font-semibold leading-[1.15] text-ink">
            Cum funcționează monitorizarea accesului
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            Concret, sistemul urmărește un singur lucru: momentul în care elevul intră sau iese din instituție.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="mt-10 flex flex-col md:flex-row md:items-stretch gap-4 md:gap-0">
          {FLOW_STEPS.map((step, i) => (
            <div key={i} className="flex flex-1 items-center gap-4 md:gap-0">
              <div data-testid={`flow-step-${i}`} className="flex-1 rounded-2xl border border-slate-200 bg-slate-50 p-6">
                <span className="font-serif text-2xl font-semibold text-isic">0{i + 1}</span>
                <p className="mt-3 text-[15px] font-medium leading-snug text-ink">{step}</p>
              </div>
              {i < FLOW_STEPS.length - 1 && (
                <div className="flex shrink-0 items-center justify-center md:px-4 text-slate-300">
                  <ArrowRight size={22} className="hidden md:block" />
                  <ArrowDown size={22} className="md:hidden" />
                </div>
              )}
            </div>
          ))}
        </div>
      </Reveal>

      <div className="mt-14 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <h3 className="font-serif text-2xl font-semibold text-ink leading-snug">
            Ce urmărește și ce nu urmărește sistemul
          </h3>
          <p className="mt-4 text-slate-600 leading-relaxed">
            O soluție construită să inspire claritate și încredere, cu respect deplin pentru intimitatea elevilor.
          </p>
        </div>
        <ul className="lg:col-span-7 grid sm:grid-cols-2 gap-x-10">
          {TRACKING_LIST.map((item, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <li>
                <div className="flex items-start gap-3 border-t border-slate-200 py-5">
                  <Check size={18} strokeWidth={2.4} className="mt-0.5 shrink-0 text-isic" />
                  <span className="text-[15px] leading-relaxed text-slate-700">{item}</span>
                </div>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>

      <Reveal delay={0.1}>
        <div
          data-testid="trust-block"
          className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 rounded-3xl bg-ink px-8 py-8 text-center"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-isic/20 text-isic">
            <ShieldOff size={24} strokeWidth={1.8} />
          </span>
          <p className="font-serif text-2xl sm:text-3xl font-semibold text-white">
            Fără localizare. Fără urmărire în afara școlii.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
